<template>
	<div class="app-body">
		<div class="sidebar">
			<side-bar />
		</div>
		<main class="main">        
			<bread-crumb />
			<transition name="fade" mode="out-in">
				<keep-alive>
					<router-view :key="$route.fullPath" /> 
				</keep-alive>
			</transition>
		</main>
		<quick-add />
		<auto-logout />

		<checkin-create-modal v-if="perms.can_create_checkin" />
		<physician-create-modal v-if="perms.can_create_physician" />
		<route-create-modal v-if="perms.can_create_route" ref="routeCreateModal" />      
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import SideBar from './SideBar';
	import QuickAdd from './QuickAdd';
	import BreadCrumb from './BreadCrumb';
	import AutoLogout from '../components/AutoLogout';

	export default {
		components: {
			SideBar,
			BreadCrumb,
			QuickAdd,
			AutoLogout
		},

		created() {
			this.setLayout();
		},

		methods: {
			setLayout() {
				let layout = 'desktop';
				if (this.$root.$mq == 'xs' || this.$root.$mq == 'sm') {
					layout = 'mobile';
				}				
				this.$store.commit('setLayout', layout);				
			}
		},

		computed: mapState(['config', 'perms']),

		watch: {
		    '$root.$mq'() {
		    	this.setLayout();
			}
        },
	}

</script>

<style>
	.fade-enter {
	  opacity: 0;
	}

	.fade-enter-active {
	  transition: opacity .1s ease;
	}

	.fade-leave {}

	.fade-leave-active {
	  transition: opacity .1s ease;
	  opacity: 0;
	}
</style>